import '@morioh/v-lightbox/dist/lightbox.css'
import '@/assets/scss/img_gallery.css'
import Vue from 'vue'
import Lightbox from '@morioh/v-lightbox'

// global register
Vue.use(Lightbox)
